module.exports = __webpack_public_path__ + "img/3.c6741f6d.png";